import { AgGridReact } from 'ag-grid-react';
import React, { useEffect, useMemo, useState } from 'react';
import { useAdminCommonStore } from 'src/hooks/admin/adminCommon';
import { useUserStore } from 'src/hooks/admin/user';
import useReduxState from 'src/hooks/useReduxState';
import { __remove, __set } from 'src/store/axios_indicator';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Helper from 'src/helper/Helper';
import NoResultContent from '../../HomePageContent/NoResultContent';
import { Tooltip } from 'src/component/Global/Tooltip';
import { useObjCommonFilterStore } from "../../../hooks/objCommonFilter";
import System from 'src/helper/system';

var roleData = [];

const UserSearchAcctList = (props) => {
  const [__check] = useAxiosIndicatorCheck();
  const [{ searchSponsorAccounts }, {
    get_search_sponsor_accounts_list
  }, { set_search_sponsor_accounts_list }] = useUserStore();
  const [{ roleList }, { get_role_list }, { }] = useAdminCommonStore();
  const [rowData, setRowData] = useState([]);
  const [{ userSearchAcctPopupStatus, selectedRoles, selectedAccounts }, { }, {
    set_role_selection_popup_status, set_select_user_sponsor_accounts, set_selected_accounts
  }] = useUserStore();
  const [{ filter_list }, { }] = useObjCommonFilterStore();
  const [disableSearch] = useReduxState(true, 'setDisableAccountSearch');
  const gridRef = React.useRef();
  const userData = props.userData;
  const [selectedIndex, setIndex] = useState(-1);
  const [{ userAcctList }] = useUserStore();
  const [, setIsSponsorRoleSelect] = useReduxState(false, 'setIsSponsorRoleSelect');

  useEffect(() => {
    roleData = roleList;
  }, [roleList])

  const addRole = (e) => {
    const role = e.data.Role;
    let renderedRole = Helper.renderRoles(role, roleData);
    const cellContent = e.data.selected ? <a className={'text-blue2'} onClick={() => {
      openPopup(e.data, e.rowIndex)
    }}><u>
        {role.length > 0 ? renderedRole : 'Select a Role (required)'}
      </u>
    </a> : <span className={'text-black-stone'}>{role.length > 0 ? renderedRole : 'Select a Role (required)'}</span>

    return role.length > 0 ? <Tooltip
      arrow={false}
      position={'top left'}
      opener={() => cellContent}
      content={() => `${renderedRole}`}
    /> : cellContent;
  }
  const roleSortingAgGrid = (roleA, roleB) => {
    let renderedRoleA = Helper.renderRoles(roleA, roleData);
    let renderedRoleB = Helper.renderRoles(roleB, roleData);
    return renderedRoleA.localeCompare(renderedRoleB);
  }

  useEffect(() => {
    if (selectedIndex < 0) {
      return;
    }
    const role = selectedRoles.map((role) => {
      return role.roleName;
    }).join(', ');
    let accList = [...searchSponsorAccounts];
    accList = accList.map(item => {
      if (item['key'] === selectedIndex) {
        return {
          ...item,
          ['rolename']: role
        };
      }
      return item;
    });

    set_search_sponsor_accounts_list(accList);
    setIndex(-1)
  }, [selectedRoles]);

  const openPopup = (account, rowIndex) => {
    setIsSponsorRoleSelect(true);
    setIndex(account?.key)
    set_select_user_sponsor_accounts({ account, userData: { userName: userData.userDetail.firstName + " " + userData.userDetail.lastName } })
    set_role_selection_popup_status(true);
  };
  const [columnDefs] = useState([
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      showDisabledCheckboxes: true,
      width: 50,
      tooltipValueGetter: (params) => {
        return params.node.selectable ? null : "This account is already sponsored"
      },
      unSortIcon: true
    },
    { field: 'AccountNumber',unSortIcon: true },
    { field: 'AccountName', },
    { field: 'Role', cellRenderer: addRole, sortable: true, width: 231, comparator: roleSortingAgGrid,unSortIcon: true},
    { field: 'SalesOrg',unSortIcon: true },
  ]);

  useEffect(() => {
    if (!userSearchAcctPopupStatus) {
      setRowData([]);
    }
  }, [userSearchAcctPopupStatus])

  const onSelectionChanged = (event) => {
    set_selected_accounts(event.api.getSelectedRows());
  }
  useEffect(() => {
    gridRef?.current?.api?.forEachNode((node) => {
      const acc = selectedAccounts.find((a) => {
        return a.key === node.data.key;
      })
      node?.setData({
        ...node?.data,
        Role: node?.data?.Role,
        selected: !!acc
      })
      acc && node?.setSelected(true);
    });
  },)

  const defaultColDef = React.useMemo(() => {
    return {
      sortable: true,
      filter: true,
      enableRowGroup: false,
      enableValue: true,
      suppressMovable: true,
      resizable: true
      // maxWidth: 250
    };
  }, []);
  useEffect(() => {
    get_role_list()
  }, []);

  useEffect(() => {
    async function fetchHere() {
      await fetchAPICall()
    }

    fetchHere();
  }, [filter_list,]);

  useEffect(() => {
    let _acctList = [];
    if (searchSponsorAccounts?.length > 0) {
      searchSponsorAccounts.map((_user, idx) => {
        let _data = {
          AccountNumber: _user.accountNumber,
          AccountName: _user.accountName,
          Role: _user.rolename ? _user.rolename.split(',').map(v => v.trim()) : [],
          SalesOrg: _user.salesOrg,
          key: idx,
          selected: false
        }
        _acctList.push(_data);
      })
    }
    setRowData(_acctList)
  }, [searchSponsorAccounts]);

  const fetchAPICall = async () => {
    if (disableSearch) {
      return;
    }
    set_selected_accounts([]);
    __set('USER_API_CALL')
    if (!Helper.checkObjectHaveValue(filter_list)) {
      const params = {
        userId: userData.userId?.trim?.(),
        accountNumber: filter_list.accountNumber?.searchKeyword?.trim?.() || '',
        accountName: filter_list.accountName?.searchKeyword?.trim?.() || '',
        speedBoat: [System.avUserInfoData.speedBoatAbbr?.trim?.()],
        salesOrg: filter_list.salesOrg?.searchKeywordArr?.map((v) => v.value?.trim?.()) || [],
      }
      const res = await get_search_sponsor_accounts_list(params)
      if (res?.payload?.Message) {
        system_alert_indicator({
            name: "accessDenied",
            message: data?.payload?.Message,
            type: "danger",
            isDisplayIcon: true,
            isDisplay: false
        });
    }
    } else {
      set_search_sponsor_accounts_list([]);
    }
    __remove('USER_API_CALL')
  };

  const isRowSelectable = useMemo(() => {
    return (params) => {
      const found = userAcctList.find((acc) => {
        //const accSB = speedboatMapping[acc.speedboat]
        return acc.accountNumber === params.data.AccountNumber && acc.salesOrg === params.data.SalesOrg;
      })
      return !found;
    };
  }, []);
  const onColumnResided = (event) => {
    event.columnApi.getColumn('0').setActualWidth(50);
  }
  const onGridReady = (params) => {
    params.api.addEventListener('columnResized', onColumnResided);
    params.api.sizeColumnsToFit();
  }
  const rowClassRules = {
    'text-black-stone': (params) => (params.data.Role.length > 0), // Example condition to disable row
  };

  return (
    <>
      {__check(['USER_API_CALL']).render}
      {!__check(['USER_API_CALL']).status &&
        <>
          {(rowData?.length > 0 && roleList?.length > 0) ?
            <div className='adminconsole-container'>
              <div className="ag-theme-alpine ag-grd-hg mb-5">
                <AgGridReact
                  ref={gridRef}
                  rowData={rowData}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  rowSelection={'multiple'}
                  suppressRowClickSelection={true}
                  isRowSelectable={isRowSelectable}
                  onSelectionChanged={onSelectionChanged}
                  debounceVerticalScrollbar={true}
                  onGridReady={onGridReady}
                  rowClassRules={rowClassRules}
                >
                </AgGridReact>
              </div>
            </div>
            :
            <>
              {!Helper.checkObjectHaveValue(filter_list) &&
                <div className='mt-5 alert-center mx-4'>
                  <NoResultContent message={"Sorry! We can't find any results based on your selection."}
                    isDisplay={false} />
                </div>
              }
            </>
          }
        </>}
    </>
  )
}

export default UserSearchAcctList;